
<template>
    <div>
        <div class="operate_item" style="font-weight: bold;border-bottom: 1px solid #ccc">
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12"><span class="left">{{$t('main.FillingRestrictions')}}</span></el-col>
        </div>
        <div class="fillInSetting">
            <!-- 内容限制 -->
            <div v-if="activeQuestion.format != undefined" class=" box">
                <span class="left">{{$t('main.ContentRestrictions')}}</span>
                <span class="right">
                    <el-select v-model="activeQuestion.format" @change="formatChange" :placeholder="$t('main.PleaseSelect')" size="mini">
                        <el-option v-for="item in ContentRestrictions" :key="item.label" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </span>
            </div>
            <!-- 字数限制 -->
            <div v-if="activeQuestion.maxNum != undefined && activeQuestion.minNum != undefined
                && 
                (activeQuestion.format == '0' 
                || activeQuestion.format == '1'
                || activeQuestion.format == '2'
                || activeQuestion.format == '3'
                || activeQuestion.format == '4'
                )" 
                class="box border-none" style="display: block;">
                <span v-if="activeQuestion.format == '1'" class="left">范围限制</span>
                <span v-else class="left">{{$t('main.WordLimit')}}</span>
            </div>
            <div v-if="activeQuestion.format == '1'" 
                class="box border-none" style="display: block;">
                <span class="left">{{$t('main.FillInAtLeast')}}</span>
                <div class="right" style="font-size: 14px">
                    <el-select v-model="activeQuestion.decimalPlaces" placeholder="请选择" size="mini">
                        <el-option v-for="item in 6" :key="item - 1" :label="item - 1" :value="item - 1"></el-option>
                    </el-select>
                </div>
            </div>
            <div v-if="activeQuestion.minNum  != undefined
                && 
                (activeQuestion.format == '0' 
                || activeQuestion.format == '1'
                || activeQuestion.format == '2'
                || activeQuestion.format == '3'
                || activeQuestion.format == '4'
            )" class="box border-none">
                <span v-if="activeQuestion.format == '1'"  class="left">最小值</span>
                <span v-else class="left">最少字数</span>
                <div class="right" style="font-size: 14px">
                    <PopoverNum
                        :value="activeQuestion.minNum"
                        controls-position="right"
                        :size="'mini'"
                        :min="activeQuestion.minNum"
                        :max="activeQuestion.maxNum"
                        :type="'min<max'"
                        :maxlength="4"
                        :content="activeQuestion.format == '1' ? '最小值不得大于等于最大值' : $t('main.MinimumMustNotBeGreaterThanOrEqualToMaximum')"
                        :valueType="activeQuestion.format == '1' ? 'numValue' : 'lengthValue'"
                        @valueChange="(val) => activeQuestion.minNum = val"
                    >
                    </PopoverNum>
                </div>
            </div>
            <div v-if="activeQuestion.maxNum  != undefined
                && 
                (activeQuestion.format == '0' 
                || activeQuestion.format == '1'
                || activeQuestion.format == '2'
                || activeQuestion.format == '3'
                || activeQuestion.format == '4'
            )" class="box border-none">
                <span v-if="activeQuestion.format == '1'"  class="left">最大值</span>
                <span v-else class="left">{{$t('main.atMost')}}</span>
                <div class="right" style="font-size: 14px">
                    <PopoverNum
                        :value="activeQuestion.maxNum"
                        controls-position="right"
                        :size="'mini'"
                        :min="activeQuestion.minNum"
                        :max="activeQuestion.maxNum"
                        :type="'min>max'"
                        :maxlength="4"
                        :content="activeQuestion.format == '1' ? '最大值不得小于等于最小值' : $t('main.MaximumMustNotBLessThanOrEqualToMinimum')"
                        :valueType="activeQuestion.format == '1' ? 'numValue' : 'lengthValue'"
                        @valueChange="(val) => activeQuestion.maxNum = val"
                    >
                    </PopoverNum>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PopoverNum from "@/components/myComponents/popoverNum.vue"
export default {
    name: 'FillInLimit', // 填写限制
    components:{
        PopoverNum
    },
    props: {
        activeQuestion: {
            type: Object,
            default: () => {}
        },
        ContentRestrictions: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return{
        }
    },
    created() {
    },
    methods: {
        formatChange(e) {
            if(e != 1) {
                this.activeQuestion.decimalPlaces = 0
                if (this.activeQuestion.minNum < 0)  this.activeQuestion.minNum = 0
                if (this.activeQuestion.maxNum < 0) this.activeQuestion.maxNum = 0
            }
        }
    }
} 
</script>

<style scoped lang="scss">
.fillInSetting{        
    width: 90%;
    margin: 0px auto;
    font-size: 14px;
    .box{
        min-height: 49px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ccc;
        line-height: 40px;
    }
    .border-none{
        border: none;
    }
}
</style>